/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/ig) != null) {
      len += 1
    } else {
      len += 0.5
    }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' +
      encodeURIComponent(json[key])
  })).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function scrollTo(element, to, duration) {
  if (duration <= 0) return
  const difference = to - element.scrollTop
  const perTick = difference / duration * 10
  setTimeout(() => {
    element.scrollTop = element.scrollTop + perTick
    if (element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  }, 10)
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}


export function getFileName(verCodeImg) {
  let obj = verCodeImg.lastIndexOf("/");
  let fileName = verCodeImg.substr(obj + 1)
  var pattern = /\.{1}[a-z]{1,}$/
  if (pattern.exec(fileName) !== null) {
    return (fileName.slice(0, pattern.exec(fileName).index))
  } else {
    return fileName
  }
}

export function coppyArray(coppyData) {

  return coppyData.map((e) => {
    if (typeof e === 'object') {
      return Object.assign({}, e);
    } else {
      return e;
    }
  })
}

//数据克隆
export function clone(obj) {
  let buf;
  if (obj instanceof Array) {
    buf = [];
    let i = obj.length;
    while (i--) {
      buf[i] = clone(obj[i]);
    }
    return buf;
  } else if (obj instanceof Object) {
    buf = {};
    for (let k in obj) {
      buf[k] = clone(obj[k]);
    }
    return buf;
  } else {
    return obj;
  }
}

//数据克隆 // code //后台返回 rtnCode  type 成功或者失败， modelName 模块名称， operateType操作类型(0，查询1:添加,2:修改,3,删除,4:下载,5:导出,6:上传)
export function messageBox(code, type, modelName, operateType) {
  messageBox(rtnCode, 0, "userMge", 0)
  if (type == 0) {
    this.$message({
      message: this.$t("organizationMge.delSuccess"),
      type: 'success',
      duration: 1000
    })
  } else {
    this.$message.error(this.$t("organizationMge.delError"));
  }

}

//两个日期创建数组
export function getDateList(startDate, endDate) {
  const dateList = []
  dateList.push(startDate)
  while (true) {
    startDate.setDate(startDate.getDate() + 1)
    if (startDate.getTime() < endDate.getTime()) {
      dateList.push(startDate)
    } else {
      break
    }
  }
  dateList.push(endDate)
  return dateList
}

/**
 *
 * @param d1 第一个时间
 * @param d2 第二个时间
 * 两个时间比大小
 * @constructor
 */
export function compareDate(d1, d2) {
  return ((new Date(d1)) > (new Date(d2)));
}

export function distinct(arr) {
  let len = arr.length;
  for (let i = 0; i < len; i++) {
    for (let j = i + 1; j < len; j++) {
      if (arr[i].orgId == arr[j].orgId) {
        arr.splice(j, 1);
        len--;
        j--;
      }
    }
  }
  return arr;
}

// 获取网址绝对路径
export function GetUrlRelativePath() {
  const url = document.location.toString();
  const arrUrl = url.split("//");

  const start = arrUrl[1].indexOf("/");
  let relUrl = arrUrl[1].substring(start);//stop省略，截取从start开始到结尾的所有字符

  if (relUrl.indexOf("?") != -1) {
    relUrl = relUrl.split("?")[0];
  }
  return relUrl;
}

/**
 *
 * @param name 获取url？后的值
 * @returns {string | null}
 */
export function getUrlKey(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

export function treeRenderContent(h, {node, data, store}) {
  console.log('h, {node, data, store}', h, {node, data, store})
  if (data.orgType == 90) {
    return (
      <span class="custom-tree-node">
              <div>
                <i
                  class="file-btn-icon el-icon-control-NMP CBX-ICON"
                  style="color:#30A3FB;font-size: 12px;"
                >
              {" "}
            </i>
                <i class="el-icon-control-model_211" style="color: #1d8fff;font-size: 12px;margin-left: 5px"></i>
              </div>

            <span style="margin-left: 5px;font-size: 14px;" title={node.label}>
              {" "}
              {node.label}{" "}
            </span>
          </span>
    )
      ;
  } else if (data.orgType == 91) {
    return (
      <span class="custom-tree-node">
            <i class="file-btn-icon el-icon-control-MBX" style="color: #0544FF;font-size: 12px;"></i>
            <span style="margin-left: 5px;font-size: 14px;" title={node.label}>{node.label}</span>
          <span>
          </span>
          </span>);
  } else if (data.orgType == 92) {
    return (
      <span class="custom-tree-node">
            <i class="file-btn-icon el-icon-control-a-TSC-black1"
               style="font-size: 12px;background-image:-webkit-linear-gradient(#A15EFF,#8000FF);-webkit-background-clip:text;-webkit-text-fill-color:transparent;"> </i>
            <span style="margin-left: 5px;font-size: 14px;" title={node.label}>{node.label}</span>
          <span>
          </span>
          </span>);
  } else if (data.orgType == 93) {
    return (
      <span class="custom-tree-node">
            <i
              class="file-btn-icon el-icon-control-a-icon_nps-copy CBX-ICON"
              style="font-size: 12px;background-image:-webkit-linear-gradient(#2af8dc,#08c4f8);-webkit-background-clip:text;-webkit-text-fill-color:transparent;"
            >
              {" "}
            </i>
        <i class="el-icon-control-model_100" style="color: #1d8fff;font-size: 12px;margin-left: 5px"></i>
            <span style="margin-left: 5px;font-size: 14px;" title={node.label}>
              {" "}
              {node.label}{" "}
            </span>
            <span/>
          </span>
    );
  } else if (data.orgType == 94) {
    return (
      <span class="custom-tree-node">
              <div>
                <i
                  class="file-btn-icon el-icon-control-NDP-black CBX-ICON"
                  style="font-size: 12px;background-image:-webkit-linear-gradient(#FFCC6F,#ED812C);-webkit-background-clip:text;-webkit-text-fill-color:transparent;"
                >
              {" "}
            </i>
                <i class="el-icon-control-model_100" style="color: #1d8fff;font-size: 12px;margin-left: 5px"></i>
              </div>

            <span style="margin-left: 5px;font-size: 14px;" title={node.label}>
              {" "}
              {node.label}{" "}
            </span>
            <span/>
          </span>
    );
  } else if (data.orgType == 95) {
    return (
      <span class="custom-tree-node">
              <div>
                <i
                  class="file-btn-icon el-icon-control-NDP-black CBX-ICON"
                  style="font-size: 12px;background-image:-webkit-linear-gradient(#FFCC6F,#ED812C);-webkit-background-clip:text;-webkit-text-fill-color:transparent;"
                >
              {" "}
            </i>
                <i class="el-icon-control-model_500" style="color: #1d8fff;font-size: 12px;margin-left: 5px"></i>
              </div>

            <span style="margin-left: 5px;font-size: 14px;" title={node.label}>
              {" "}
              {node.label}{" "}
            </span>
            <span/>
          </span>
    );
  } else if (data.orgType == 96) {
    return (
      <span class="custom-tree-node">
              <div>
                <i
                  class="file-btn-icon el-icon-control-NDP-black CBX-ICON"
                  style="font-size: 12px;background-image:-webkit-linear-gradient(#FFCC6F,#ED812C);-webkit-background-clip:text;-webkit-text-fill-color:transparent;"
                >
              {" "}
            </i>
                <i class="el-icon-control-model_600" style="color: #1d8fff;font-size: 12px;margin-left: 5px"></i>
              </div>

            <span style="margin-left: 5px;font-size: 14px;" title={node.label}>
              {" "}
              {node.label}{" "}
            </span>
            <span/>
          </span>
    );
  } else if (data.orgType == 97) {
    return (
      <span class="custom-tree-node">
              <div>
                <i
                  class="file-btn-icon el-icon-control-NMP CBX-ICON"
                  style="color:#30A3FB;font-size: 12px;"
                >
              {" "}
            </i>
                <i class="el-icon-control-model_311" style="color: #1d8fff;font-size: 12px;margin-left: 5px"></i>
              </div>

            <span style="margin-left: 5px;font-size: 14px;" title={node.label}>
              {" "}
              {node.label}{" "}
            </span>
          </span>
    );
  } else if (data.orgType == 98) {
    return (
      <span class="custom-tree-node">
              <div>
                <i
                  class="file-btn-icon el-icon-control-NDP-black CBX-ICON"
                  style="font-size: 12px;background-image:-webkit-linear-gradient(#FFCC6F,#ED812C);-webkit-background-clip:text;-webkit-text-fill-color:transparent;"
                >
              {" "}
            </i>
                <i class="el-icon-control-model_200" style="color: #1d8fff;font-size: 12px;margin-left: 5px"></i>
              </div>

            <span style="margin-left: 5px;font-size: 14px;" title={node.label}>
              {" "}
              {node.label}{" "}
            </span>
          </span>
    );
  } else if (data.orgType == 99) {
    return (
      <span class="custom-tree-node">
              <div>
                <i
                  class="file-btn-icon el-icon-control-a-icon_nps-copy CBX-ICON"
                  style="font-size: 12px;background-image:-webkit-linear-gradient(#2af8dc,#08c4f8);-webkit-background-clip:text;-webkit-text-fill-color:transparent;"
                >
              {" "}
            </i>
                <i class="el-icon-control-model_150" style="color: #1d8fff;font-size: 12px;margin-left: 5px"></i>
              </div>

            <span style="margin-left: 5px;font-size: 14px;" title={node.label}>
              {" "}
              {node.label}{" "}
            </span>
          </span>
    );
  } else if (data.orgType == 100) {
    return (
      <span class="custom-tree-node">
              <div>
                <i
                  class="file-btn-icon el-icon-control-sl CBX-ICON"
                  style="font-size: 12px;background-image:-webkit-linear-gradient(#FFF06E,#D7B100);-webkit-background-clip:text;-webkit-text-fill-color:transparent;"
                >
              {" "}
            </i>
                <i class="el-icon-control-model_100" style="color: #1d8fff;font-size: 12px;margin-left: 5px"></i>
              </div>

            <span style="margin-left: 5px;font-size: 14px;" title={node.label}>
              {" "}
              {node.label}{" "}
            </span>
          </span>
    );
  } else {
    return (
      <span class="custom-tree-node">
            <span style="margin-left: 10px;font-size: 14px;" title={node.label}>{node.label}</span>
          <span>
          </span>
          </span>);
  }
}





// WEBPACK FOOTER //
// ./src/utils/index.js